<ng-container *ngIf="logo$ | async as logo">
  <mat-progress-bar
    mode="indeterminate"
    class="tvp-content-loader"
    color="primary"
    [class.is-loading]="isLoading$ | async"
  ></mat-progress-bar>
  <mat-toolbar>
    <mat-toolbar-row>
      <img class="tvp-logo" [src]="logo | mdsSafe: 'url'" alt="logo" />
      <div fxFlex></div>
      <button
        mat-icon-button
        matTooltip="{{ 'Tvp.Appointment.Contact' | translate }}"
        color="primary"
        (click)="contact()"
      >
        <mat-icon>contact_support</mat-icon>
      </button>
      <mds-select-culture></mds-select-culture>
    </mat-toolbar-row>
  </mat-toolbar>
  <mat-drawer-container class="tvp-drawer-content">
    <mat-drawer-content>
      <div fxLayoutAlign="center start" fxFlex>
        <div class="tvp-main-content" fxFlex>
          <router-outlet></router-outlet>
        </div>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</ng-container>
